import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

const DEFAULT_ITEM_COUNT = 4;

interface ListSkeletonProps {
  itemCount?: number;
  className?: string;
}

export function ListSkeleton({ itemCount = DEFAULT_ITEM_COUNT, className }: ListSkeletonProps) {
  const itemKeys = Array.from({ length: itemCount }, (_, item) => `skeleton-item-${item}`);

  return (
    <ul className={cn('divide-y rounded-lg border', className)} aria-busy="true">
      {itemKeys.map((itemKey) => (
        <li key={itemKey} className="flex items-center gap-3 p-3">
          <Skeleton className="size-4 shrink-0" />
          <div className="flex min-w-0 flex-1 flex-col gap-1.5">
            <Skeleton className="h-4 w-1/2" />
            <Skeleton className="h-3 w-1/3" />
          </div>
        </li>
      ))}
    </ul>
  );
}
